export var UserForgotPasswordRoutes = {
    "/forgot-password?returnUrl": {
        "name": "forgot-password",
        "clearPrevState": true,
        "type": "frontend",
        "params": {code: '', returnUrl: ''},
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "component": "userForgotPasswordComponent",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Forgot password"
            }
        ],

        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./user-forgot-password.module.js");
                }
            },

        ],
    },


    "/user/reset/password/token?code&returnUrl&email&phone": {
        "name": "reset-password",
        "clearPrevState": true,
        "type": "frontend",
        "params": {returnUrl: ''},
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "component": "userResetPasswordComponent",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Reset Password"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./user-forgot-password.module.js");
                }
            },

        ],
    },

};
